import { LocalStorageKey } from "@/Modules/App/Models/Localstorage/LocalStorageKey";
import { LocalStorageNamespace } from "@/Modules/App/Models/Localstorage/LocalStorageNamespace";

import { LocalStorageService } from "@/Services/LocalStorageService";

import useAuthStore from "@/Modules/Auth/Store";
import { isValidString } from "@/Utils/String";

function setUserTokenAH(token: string): void {
  const authStore = useAuthStore();
  const authLocalStorageService: LocalStorageService = new LocalStorageService(LocalStorageNamespace.AUTH);

  authLocalStorageService.set(LocalStorageKey.USER_TOKEN, token);

  if (isValidString(token)) {
    authStore.userToken = token;
  }
}

export default setUserTokenAH;
